import { FaCheck } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

type CheckboxProps = {
  checked: boolean;
  text: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & React.HTMLAttributes<HTMLElement>;

const Checkbox = ({ checked, text, disabled = false, onChange, ...props }: CheckboxProps) => {
  return (
    <label
      {...props}
      className={twMerge(
        'inline-flex select-none items-center whitespace-nowrap font-manrope text-sm font-bold tracking-wide text-ph-gray-silver hover:cursor-pointer hover:text-ph-gray-white',
        checked && 'text-ph-gray-white',
        disabled && '!cursor-default !text-ph-gray-silver',
        props.className,
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event)}
        className="hidden"
      />
      {checked ? (
        <span
          className={twMerge(
            'm-h-5 mr-2 h-5 min-h-5 w-5 min-w-5 rounded-md bg-ph-primary-violet hover:cursor-pointer',
            disabled && 'cursor-default bg-ph-gray-silver hover:cursor-default',
          )}
        >
          <FaCheck className="ml-1 mt-1 h-3 w-3 text-ph-gray-white" />
        </span>
      ) : (
        <span
          className={twMerge(
            'm-h-5 mr-2 h-5 w-5 min-w-5 rounded-md bg-ph-gray-baltic hover:cursor-pointer',
            disabled && 'cursor-default bg-ph-gray-silver hover:cursor-default',
          )}
        ></span>
      )}
      {text}
    </label>
  );
};

export default Checkbox;
